import { cva } from 'class-variance-authority';
const badgeVariantMap = {
    default: 'border-transparent bg-primary text-primary-foreground [a&]:hover:bg-primary/90',
    secondary: 'border-transparent bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90',
    destructive: 'border-transparent bg-destructive text-white [a&]:hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60',
    outline: 'text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground',
    success: 'border-transparent bg-success text-success-foreground [a&]:hover:bg-success/90',
    warning: 'border-transparent bg-warning text-warning-foreground [a&]:hover:bg-warning/90',
};
/** 칩형 — 컨트롤 높이 토큰을 억지로 쓰지 않고 패딩·글자만 densify. */
const badgeSizeMap = {
    default: 'px-2 py-0.5 text-xs [&>svg]:size-3',
    md: 'px-2 py-0.5 text-xs [&>svg]:size-3',
    sm: 'px-1.5 py-0 text-[0.625rem] [&>svg]:size-2.5',
    lg: 'px-2.5 py-1 text-sm [&>svg]:size-3.5',
};
export const badgeCva = {
    variants: {
        variant: badgeVariantMap,
        size: badgeSizeMap,
    },
    defaultVariants: {
        variant: 'default',
        size: 'default',
    },
};
export const badgeVariants = cva('inline-flex items-center justify-center rounded-md border font-medium w-fit whitespace-nowrap shrink-0 space-x-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden', badgeCva);
export const badgeVariantKeys = Object.keys(badgeCva.variants.variant);
export const badgeSizeKeys = Object.keys(badgeCva.variants.size);
//# sourceMappingURL=badge.cva.js.map